import ScrollLocker from './ScrollLocker';
export default {
  install: function install(Vue) {
    Vue.directive('lock-scroll', {
      bind: function bind(el, binding) {
        if (binding.modifiers.skip) {
          el.dataset.skipLocker = true;
        }
      },
      inserted: function inserted(el, binding) {
        if (binding.modifiers.skip) {
          return;
        }

        var isLock = binding.hasOwnProperty('value') ? !!binding.value : true;

        if (isLock) {
          ScrollLocker.lock(el);
        }
      },
      componentUpdated: function componentUpdated(el, binding) {
        if (binding.modifiers.skip) {
          return;
        }

        var isLock = binding.hasOwnProperty('value') ? !!binding.value : true;

        if (isLock) {
          ScrollLocker.lock(el);
        } else {
          ScrollLocker.unlock(el);
        }
      },
      unbind: function unbind(el, binding) {
        if (binding.modifiers.skip) {
          return;
        }

        ScrollLocker.unlock(el);
      }
    });
  }
};